import { Link } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";
import { lp } from "../lib/urls";

export const PrivacyConsent = ({ id }) => {
  const { t } = useTranslation();
  return (
    <label htmlFor={id} className="flex items-start gap-3 cursor-pointer select-none" data-testid={`${id}-label`}>
      <input
        id={id}
        type="checkbox"
        required
        data-testid={id}
        className="mt-0.5 h-4 w-4 shrink-0 accent-yellow-500 cursor-pointer"
      />
      <span className="text-xs text-gray-500 leading-relaxed">
        <Trans
          i18nKey="forms.privacyAccept"
          components={[
            <Link
              to={lp("/privacy-policy")}
              target="_blank"
              rel="noopener noreferrer"
              className="underline underline-offset-2 text-gray-950 hover:text-yellow-600 transition-colors"
            />,
          ]}
        />
      </span>
    </label>
  );
};
